import React, {FC, useState} from "react";
import {IconButton} from "@material-ui/core";
import DataRow from "view/components/DataRow";
import uniqid from "uniqid";
import EditIcon from "@material-ui/icons/Edit";
import {unitSystems} from "constraints/general";
import {
  IBaseStandSize,
  IExhibitorPair,
  IShow,
  ShowUnitSystem,
} from "@evennt-tech/api-v2-core";
import {IUpdateExhibitorBodyReq} from "@evennt-tech/api-v2-external";
import EditModal from "./EditModal";
import useStyles from "./styles";

type Props = {
  onUpdate: (value: IUpdateExhibitorBodyReq) => void;
  exhibitorPair: IExhibitorPair;
  show: IShow;
  isShowAdmin: boolean;
};

export const getStandSizeValue = (
  standSize: IBaseStandSize,
  showUnitSystem: ShowUnitSystem
) => {
  if (!standSize) {
    return "";
  }

  if (
    Number(standSize.width) === 0 &&
    Number(standSize.length) === 0 &&
    Number(standSize.area) === 0
  ) {
    return "";
  }
  const unitsObj = unitSystems.find(({value}) => value === showUnitSystem);

  const standSizeValue = `${standSize.width}${unitsObj?.units} x ${standSize.length}${unitsObj?.units}, ${standSize.area}${unitsObj?.units}²`;

  return standSizeValue;
};

const SizeSettingRow: FC<Props> = ({
  exhibitorPair,
  show,
  onUpdate,
  isShowAdmin,
}) => {
  const classes = useStyles();

  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const standSize = exhibitorPair?.stand?.size;

  const value = standSize
    ? getStandSizeValue(standSize, show.unitSystem)
    : undefined;

  const onCloseEditModal = () => setShowEditModal(false);
  const onOpenEditModal = () => setShowEditModal(true);

  return (
    <>
      <DataRow
        key={uniqid()}
        label="Size"
        value={value}
        actionPanel={
          isShowAdmin ? (
            <IconButton
              className={classes.editButton}
              onClick={onOpenEditModal}
            >
              <EditIcon />
            </IconButton>
          ) : undefined
        }
        last={false}
      />
      {showEditModal && (
        <EditModal
          open={showEditModal}
          onClose={onCloseEditModal}
          onSubmit={onUpdate}
          show={show}
          exhibitorPair={exhibitorPair}
        />
      )}
    </>
  );
};

export default SizeSettingRow;
